import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { BusinessUserRole } from '@models/businesses';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-profile-id-message',
	templateUrl: './profile-id-message.component.html',
	standalone: false,
})
export class ProfileIdMessageComponent {
	@Select(BusinessUsersState.getLoggedInUserRole)
	userRole$: Observable<BusinessUserRole>;
	public ICON = ICON;
	public businessUserRole = BusinessUserRole;
}
